import { RichText as PayloadRichText, defaultJSXConverters } from "@payloadcms/richtext-lexical/react";
import type { JSXConverters } from "@payloadcms/richtext-lexical/react";

// Override paragraph converter to use <div> instead of <p> to prevent
// hydration errors from nested <p> tags in lexical rich text content.
const converters: JSXConverters = {
    ...defaultJSXConverters,
    paragraph: ({ node, nodesToJSX }) => {
        const children = nodesToJSX({ nodes: node.children });
        if (!children?.length) {
            return (
                <div>
                    <br />
                </div>
            );
        }
        return <div>{children}</div>;
    },
};

interface RichTextProps {
    content: any; // Lexical SerializedEditorState
    className?: string;
}

export default function RichText({ content, className }: RichTextProps) {
    if (!content) return null;

    return <PayloadRichText data={content} className={className} converters={converters} />;
}
